import { useNavigate } from 'react-router-dom';
import Checkout from '../pages/Checkout';

const CheckoutWrapper = () => {
  const navigate = useNavigate();
  return <Checkout navigate={navigate} />;
};

export default CheckoutWrapper;


